import * as OSS from "@/utils/aliOss"
import { checkAttachment } from "@/api/userCenter/file"
import { getFileHash, makeFileName } from "@/utils/common"
import { initOssClient } from "@/store/actions"
import { loadingService } from "@/utils/ui"

let token

export const url_prefix = "https://new-service.oss-cn-hangzhou.aliyuncs.com/"

export var uploadingCounter = 0

export function uploadToOss(file, uploadPath) {
  uploadingCounter++
  return initOssClient()
    .then(() => {
      let headers = {
        "Cache-Control": "public, max-age=31536000"
      }
      // 大于10MB使用断点续传
      if (file.size > 10485760) {
        return OSS.resumeUpload(uploadPath, file, {
          headers,
          partSize: 10485760
        })
      } else {
        // 普通上传
        return OSS.put(uploadPath, file, {
          headers
        })
      }
    })
    .finally(() => {
      uploadingCounter--
    })
}

export function getUrlByPath(path) {
  if (!path) return ""
  return url_prefix + path
}

export async function uploadFile(file, path) {
  file.fileName = makeFileName(file)
  let uploadPath = path + file.fileName
  // 设置hash值
  if (!file.hash) {
    let loadingInstance = loadingService({ text: "校验文件中,请稍后" })
    file.hash = await getFileHash(file)
    loadingInstance.close()
  }
  // 检查是否已经上传过了
  let res = await checkAttachment(file.hash)
  let hasUpload = !!res.data.data
  // 没上传过就先上传OSS
  let ossRes
  if (!hasUpload) {
    try {
      ossRes = await uploadToOss(file, uploadPath)
      if (ossRes.res.status !== 200) {
        throw "上传OSS失败!"
      }
    } catch (err) {
      throw "上传OSS失败!"
    }
  } else {
    uploadPath = res.data.data
  }
  // 设置文件的一些信息
  file.uploadPath = uploadPath
  file.url = hasUpload ? url_prefix + file.uploadPath : ossRes.url
  return file
}
